import { ToolInvocationUIPart } from 'ai'

const AddSourceMessage = ({
  part,
  icon,
}: {
  part: ToolInvocationUIPart
  icon: React.ReactNode
}) => {
  // const citations: Citation | null =
  //   part.toolInvocation.state === 'result' ? part.toolInvocation.result : null
  // const query: string | null = part.toolInvocation.args.query ?? null
  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  return (
    <div className='flex w-full flex-col items-start gap-0'>
      <div className='group/icon inline-flex h-auto w-full min-w-16 items-center justify-start gap-2 bg-transparent px-3 py-2.5 hover:bg-transparent'>
        <div className='text-muted-foreground flex w-4 shrink-0 items-center justify-center'>
          <div>{icon}</div>
        </div>
        <span className='text-foreground flex-1 text-left text-[14px] leading-5 font-medium tracking-[0] break-words whitespace-normal'>
          {part.toolInvocation.state === 'result'
            ? `Added source to knowledge base`
            : `Adding source to knowledge base...`}
        </span>
      </div>
    </div>
  )
}

export default AddSourceMessage
